import { render, staticRenderFns } from "./DialogLayout.vue?vue&type=template&id=8188f9a6"
import script from "./DialogLayout.vue?vue&type=script&lang=js"
export * from "./DialogLayout.vue?vue&type=script&lang=js"
import style0 from "./DialogLayout.vue?vue&type=style&index=0&id=8188f9a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports